/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Govern_Ai_UseInputs */



/**
* | output |
* | --- |
* | "How do admins control models and tools?" |
*
* @param {Uno_Welcome_Suggestion_Govern_Ai_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_govern_ai_use = /** @type {((inputs?: Uno_Welcome_Suggestion_Govern_Ai_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Govern_Ai_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie steuern Admins Modelle und Tools?")
	return /** @type {LocalizedString} */ ("How do admins control models and tools?")
});